/* ALVA PDP VIDEO-TO-UPSELL FLOW — scoped observer, Aug 27 2026 */
(function () {
  if (window.__alvaPdpVideoUpsellFlow) return;
  window.__alvaPdpVideoUpsellFlow = true;

  function placeRecommendations() {
    var rec = document.querySelector('.product-info product-recommendations') ||
      document.querySelector('#AlvaPdpRecommendations product-recommendations');
    var extra = document.querySelector('.product-content-below-gallery');
    if (!rec || !extra) return;

    var video = extra.querySelector('tolstoy-widget');
    var videoBlock = video && (video.closest('.product-info__block-item') || video.parentElement);
    var wrap = document.getElementById('AlvaPdpRecommendations');

    if (!wrap) {
      wrap = document.createElement('section');
      wrap.id = 'AlvaPdpRecommendations';
      wrap.className = 'alva-pdp-recommendations';
      wrap.setAttribute('aria-label', 'Complete your kitchen');
    }

    if (videoBlock) {
      if (videoBlock.nextElementSibling !== wrap) videoBlock.insertAdjacentElement('afterend', wrap);
    } else if (wrap.parentElement !== extra) {
      extra.appendChild(wrap);
    }

    if (rec.parentElement !== wrap) wrap.replaceChildren(rec);
  }

  function relevant(node) {
    if (!node || node.nodeType !== 1) return false;
    return (node.matches && node.matches('product-recommendations,.product-content-below-gallery,tolstoy-widget')) ||
      (node.querySelector && node.querySelector('product-recommendations,.product-content-below-gallery,tolstoy-widget'));
  }

  function start() {
    placeRecommendations();
    var host = document.querySelector('product-rerender') || document.querySelector('.shopify-section--main-product');
    if (!host) return;

    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      var needsPlacement = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, relevant);
      });
      if (!needsPlacement) return;

      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        placeRecommendations();
      });
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();